import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react'
import { Menu } from '../_Menu'
import Footer from '../_Footer'

import '../assets/css/emails.css'
import './Whatsup.css'
import Header from '../Header';
import { WhatsAppModel } from '../models/WhatsAppModel';
import { WhatsAppMessage } from '../models/superbit-api-models';

import EmailMessageItem from './_MessageItem';
import { Autocomplete } from '../components/_Autocomplete';
import { AutocompleteData } from '../models/Site';
import DatePicker from "react-datepicker";
import Pagger from '../components/_Pagger';
//import WhatsappWebSocket from './WhatsappWebSocket';
import WhatsappWebsocketMessages from './WebsocketMessages';
import { message, Select, AutoComplete, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShare, faFaceSmile } from '@fortawesome/free-solid-svg-icons';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import moment from 'moment';
import { useSelector } from 'react-redux';
import LoginPopup from '../login/_LoginPopUp';
import ChatsMessages from './_ChatsMessages';
import { DownloadOutlined } from '@ant-design/icons';
import WebsocketMessages from './WebsocketMessages';
import TopToolBarWhatsup from './_TopToolBarWhatsup';


const emojiList = [
    '😀',
    '😃',
    '😄',
    '😁',
    '😆',
    '😅',
    '😂',
    '🤣',
    '😭',
    '😉',
    '😗',
    '😙',
    '😚',
    '😘',
    '🥰',
    '😍',
    '🤩',
    '🥳',
    '🫠',
    '🙃',
    '🙂',
    '🥲',
    '🥹',
    '😊',
    '☺️',
    '😌',
    '😏',
    '😴',
    '😪',
    '🤤',
    '😋',
    '😛',
    '😝',
    '😜',
    '🤪',
    '🥴',
    '😔',
    '🥺',
    '😬',
    '😑',
    '😐',
    '😶',
    '😶‍🌫️',
    '🫥',
    '🤐',
    '🫡',
    '🤔',
    '🤫',
    '🫢',
    '🤭',
    '🥱',
    '🤗',
    '🫣',
    '😱',
    '🤨',
    '🧐',
    '😒',
    '🙄',
    '😮‍💨',
    '😤',
    '😠',
    '😡',
    '🤬',
    '😞',
    '😓',
    '😟',
    '😥',
    '😢',
    '☹️',
    '🙁',
    '🫤',
    '😕',
    '😰',
    '😨',
    '😧',
    '😦',
    '😮',
    '😯',
    '😲',
    '😳',
    '🤯',
    '😖',
    '😣',
    '😩',
    '😫',
    '😵',
    '😵‍💫',
    '🫨',
    '🥶',
    '🥵',
    '🤢',
    '🤮',
    '🤧',
    '🤒',
    '🤕',
    '😷',
    '🤥',
    '😇',
    '🤠',
    '🤑',
    '🤓',
    '😎',
    '🥸',
    '🤡',
    '😈',
    '👿',
    '💪',
    '👏',
    '👍',
    '👎',
    '🫶',
    '🙌',
    '👐',
    '🤲',
    '🤝',
    '🤜',
    '🤛',
    '✊',
    '👊',
    '🫳',
    '🫴',
    '🫱',
    '🫲',
    '🫸',
    '🫷',
    '👋',
    '🤚',
    '🖐️',
    '✋',
    '🖖',
    '🤟',
    '🤘',
    '✌️',
    '🤞',
    '🫰',
    '🤙',
    '🤌',
    '🤏',
    '👌',
    '🫵',
    '👉',
    '👈',
    '☝️',
    '👆',
    '👇',
    '✍️',
    '🤳',
    '🙏',
    '❤️',
    '🧡',
    '💛',
    '💚',
    '💙',
    '💜',
    '🤎',
    '🖤',
    '🤍']


type Filter = {
    searchText: string | undefined,
    fromDate: string | undefined,
    toDate: string | undefined,
    type: string | undefined,
    searchStatus: number
};

const Whatsapp = () => {
    const menuRef = useRef<Menu | null>(null);
    const navigate = useNavigate();
    const userLogged = useSelector((state: any) => state.user.value)
    const StartDateFromRef = React.createRef<DatePicker>();
    const EndDateToRef = React.createRef<DatePicker>();
    const hiddenFileInput = useRef<any>(null);
    const hiddenFileInput2 = useRef<any>(null);

    const whatsAppModel: WhatsAppModel = new WhatsAppModel();

    const [useWebScocket, setUseWebSocket] = useState<boolean>(true);
    const [forwardStatus, setForwardStatus] = useState<boolean>(false);
    const [soundFile, setsoundFile] = useState<boolean>(true);
    const [showEmoji1, setShowEmoji1] = useState<boolean>(false);
    const [showEmoji2, setShowEmoji2] = useState<boolean>(false);
    const [recipients, setRecipients] = useState<any[]>([]);
    const [recipientsAutoComplete, setRecipientsAutoComplete] = useState<Array<AutocompleteData>>([]);

    const [currentUser, setCurrentUser] = useState<any>({})
    const [messages, setMessages] = useState<any[]>([]);
    const [subMessages, setSubMessages] = useState<any[]>([]);
    const [sendMessageLoading, setSendMessageLoading] = useState<boolean>(false);
    useEffect(() => {
        if (messagesDivRef.current) {
            messagesDivRef.current.scrollTop = messagesDivRef.current.scrollHeight;
        }
    }, [subMessages])
    const [selectedMessage, setSelectedMessage] = useState<any | null>(null);
    const [groupMessages, setGroupMessages] = useState<any[]>([]);

    const [messageText, setMessageText] = useState<string>();
    const [messageImg, setMessageImg] = useState<any | null>(null);
    const [messageImgSend, setMessageImgSend] = useState<number | null>(null);
    const [showNewMessage, setShowNewMessage] = useState<boolean>(false);
    const [newMessageText, setNewMessageText] = useState<string>("")
    const [newMessageImg, setNewMessageImg] = useState<any | null>(null);

    const [customerPhoneNumber, setCustomerPhoneNumber] = useState<string | null>(null);
    const [customerName, setCustomerName] = useState<string | null>(null);
    const [userId, setUserId] = useState<string | null>(null);
    const [curUserId, setCurUserId] = useState<string | null>(null);
    const [newMessageRecipientName, setNewMessageRecipientName] = useState<string | undefined>(undefined);
    const [recipentsOptions, setRecipentsOptions] = useState<{ value: string }[]>([]);
    // const [newMessageRecipientPhoneNumber, setNewMessageRecipientPhoneNumber] = useState<string | null>(null);
    const [newMessageUserId, setNewMessageUserId] = useState<string | null>(null);
    const [forwardMessageRecipientName, setForwardMessageRecipientName] = useState<string | undefined>(undefined);
    const [forwardMessageRecipientPhoneNumber, setForwardMessageRecipientPhoneNumber] = useState<string | null>(null);
    const [forwardMessageRecipientUserId, setForwardMessageRecipientUserId] = useState<string | undefined>(undefined);
    const [transferType, setTransferType] = useState<number | null>(null);
    const [transferMessage, setTransferMessage] = useState<string | null>(null);
    const [folderType, setFolderType] = useState('all');

    const messagesDivRef = useRef<HTMLDivElement>(null);

    const [messageFilter, setMessageFilter] = useState<Filter>({
        searchText: undefined,
        fromDate: undefined,
        toDate: undefined,
        type: 'all',
        searchStatus: 0
    });
    const [filterChanged, setFilterChanged] = useState<boolean>(false)
    const [startFilterDate, setStartFilterDate] = useState<Date | null>(null)
    const [endFilterDate, setEndFilterDate] = useState<Date | null>(null)
    const [searchText, setSearchText] = useState<string | undefined>(undefined)
    const [searchStatus, setSearchStatus] = useState<string | null>(null)
    const [pagerConf, setPagerConf] = useState<any>({
        pageSize: 0,
        currentPage: 0,
        totalItems: 0
    });
    const [apiUrl, setApiUrl] = useState<string>('')


    const [openClientMessages, setOpenClientMessages] = useState<any | null>(null);

    const [statusOfLastMessage, setStatusOfLastMessage] = useState<boolean>(false);

    const getRecipientsList = async () => {
        const recipients_list = await whatsAppModel.customerCardGetUsers();
        setRecipients(recipients_list.filter((r: any) => r.phoneNumber !== null || r.whatsAppNumber !== null));
    }


    useEffect(() => {
        init();
        // setUseWebSocket(false);
        setsoundFile(false);

        const savedApiUrl = localStorage.getItem('apiUrl');
        if (savedApiUrl) {
            setApiUrl(savedApiUrl)
        }
    }, [])



    useEffect(() => {
        setRecipentsOptions([]);
        console.log('recipients', recipients)
        if (recipients && recipients.length > 0) {
            recipients.forEach((r: any) => {
                r.online = r.lastLogIn > r.lastLogOut && moment(r.lastLogIn).isAfter(moment().startOf('day'));
                if (r.userName == 'ehud@8099.co.il') {
                    console.log('ehud@8099.co.il', r.lastLogIn, r.lastLogOut, r.lastLogIn > r.lastLogOut, r.online)
                }
            });
        }
        setRecipientsAutoComplete(recipients.map((r: any) => {
            const online = r.lastLogIn > r.lastLogOut && moment(r.lastLogIn).isAfter(moment().startOf('day'));
            return {
                label: r.fullName,
                text: r.fullName,
                val: r.id,
                value: r.id,
                type: online ? 'greem' : 'red',
                online: online
            }
        }))
        const recipientsList = recipients.map((recipient, i) => {
            const online = recipient.lastLogIn > recipient.lastLogOut && moment(recipient.lastLogIn).isAfter(moment().startOf('day'));
            let style: any = { color: 'red' };
            if (online) {
                style = { color: 'green' };
            }
            return {
                label: (<span style={style}>{recipient.fullName}</span>),
                value: `${recipient.id}`,
            }
        });
        setRecipentsOptions(recipientsList)
    }, [recipients])

    useEffect(() => {
        console.log(recipientsAutoComplete)
    }, [recipientsAutoComplete])

    useEffect(() => {
        if (filterChanged) {
            loadByFilter();
            setFilterChanged(false);
        }
    }, [filterChanged])

    useEffect(() => {
        sendMessage();

    }, [messageImgSend])

    useEffect(() => {
        sendNewMessage();
    }, [newMessageImg])

    const init = async () => {
        const u = await localStorage.getItem("loggedUser");
        if (u) {
            console.log('init', u);
            setCurrentUser(JSON.parse(u));

            let filter: any;
            const selectLead = localStorage.getItem('selectedWhatsAppLead');
            if (selectLead) {
                console.log('selectLead', selectLead);
                const phone = '972' + selectLead.substring(1);
                filter = {
                    searchText: phone
                    // "phone": phone
                }
                localStorage.removeItem('sselectedWhatsAppLead');
            }

            const selectedCustomer = localStorage.getItem('selectedWhatsApCustomer');
            if (selectedCustomer) {
                const customerId = selectedCustomer;
                filter = {
                    customerId
                }
                localStorage.removeItem('selectedWhatsApCustomer');
            }
            load(filter);
        }
    }

    const getDepartment = (role: number) => {
        switch (role) {
            case 0: return "- מנהל";
            case 6: return "ממחלקת";
            case 7: return "מנהל/ת מחלקת";
            case 8: return "ממחלקת";
            case 9: return "ממחלקת";
            case 10: return "מנהל/ת מחלקת";
            case 11: return "מחלקת";
            case 12: return "מחלקת";
            case 17: return "ממחלקת";
        }
    }

    const getBranch = (branchName: string) => {
        if (branchName) {
            return branchName;
        } else {
            return '';
        }

    }

    const load = async (filter?: any) => {
        setMessages([]);
        if (!filter) {
            filter = {
                type: 'all'
            }
        } else {
            if (!filter.type) {
                filter.type = folderType;
            }
        }


        const whatsAppData = await whatsAppModel.whatsappIndex(filter);

        const loggedUser = localStorage.getItem("loggedUser");
        if (loggedUser && whatsAppData.messages && whatsAppData.messages.length > 0) {
            const currentUser: any = JSON.parse(loggedUser);

            //setMessageText("שלום, כאן "+JSON.parse(loggedUser).name+" "+getDepartment(currentUser.role)+": ");
            const messages: any[] = [];
            const subMessages: any[] = [];
            whatsAppData.messages.forEach((message: any) => {

                const d = prepareDate(message.createdDate)
                message.date = d.date;
                message.time = d.time;
                let customerName = message.customerName;
                let customerPhoneNumber = message.customerPhoneNumber;
                let userId = null;
                if (message.senderUserId && message.senderUserId != JSON.parse(loggedUser).id) {
                    userId = message.senderUserId;
                } else if (message.receiverUserId && message.receiverUserId != JSON.parse(loggedUser).id) {
                    userId = message.receiverUserId;
                }
                const senderUser = message.senderUser;
                const receiverUser = message.receiverUser;

                message.customerName = customerName;
                message.customerPhoneNumber = customerPhoneNumber;
                message.userId = userId;
                messages.push(message);
            });
            // const messagesList: any[] = [];
            // messages.forEach((message: any)=>{
            //     messagesList.push()
            // })
            setMessages(messages);
            // whatsAppData.groupMessages.forEach((messageArr: any[]) => {
            //     messageArr.forEach(message => {
            //         const d = prepareDate(message.createdDate)
            //         message.date = d.date;
            //         message.time = d.time;
            //         subMessages.push(message);
            //     })
            // });
            // setGroupMessages(subMessages)
        }

        if (recipients.length == 0) {
            // const recipients_list =await whatsAppModel.customerCardGetUsers();
            // setRecipients(recipients_list.filter((r: any) => r.phoneNumber !== null || r.whatsAppNumber !== null));
            await getRecipientsList();
        }


        const userDataStr = localStorage.getItem('loggedUser');
        const userData = userDataStr ? JSON.parse(userDataStr) : {}
        const menuPermissions = userData.menuPermissions;
        let userId = '';

        const parsedData = localStorage.getItem('loggedUser');
        if (parsedData) {
            const loggedUser = JSON.parse(parsedData)
            // setUserData(loggedUser);
            userId = loggedUser.id;

            setCurUserId(userId);

        }

    }

    const loadByFilter = async () => {
        // const whatsAppData = await whatsAppModel.whatsappSearchMessage(messageFilter.searchText, messageFilter.fromDate, messageFilter.toDate);
        // const whatsAppData = await whatsAppModel.whatsappIndex();
        // const whatsAppData = await whatsAppModel.whatsappIndex(messageFilter);
        // console.log(whatsAppData);
        load(messageFilter);
    }

    const prepareDate = (dateStr: string) => {
        let date = new Date(dateStr);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const dateString = `${day}/${month}/${year}`;

        const hours = date.getHours();
        const minutes = date.getMinutes();
        const timeString = `${hours}:${minutes}`;

        return {
            date: dateString,
            time: timeString
        }
    }
    const getMessages = () => {
        return messages;
    }

    const onOpenDateFromFocus = () => {
        if (StartDateFromRef.current) {
            StartDateFromRef.current.setFocus();
        }
    }
    // this.OpenDateToRef
    const onOpenDateToFocus = () => {
        if (EndDateToRef.current) {
            EndDateToRef.current.setFocus();
        }
    }

    const checkLastMessageFromSender = (userId: string) => {

    }

    const openMessage = async (dataObject: any) => {
        setTransferMessage("");
        setCustomerPhoneNumber(null);
        console.log('openMessage dataObject', dataObject)
        setOpenClientMessages(dataObject);

        const loggedUser = localStorage.getItem("loggedUser");
        if (loggedUser) {
            const currentUser: any = JSON.parse(loggedUser);
            let wData: any = null;

            // for check if pass 24 hours from createdDate
            const createdDate = new Date(dataObject.createdDate);
            const currentDate = new Date();
            const diffTime = Math.abs(currentDate.getTime() - createdDate.getTime());
            const diffHours = Math.ceil(diffTime / (1000 * 60 * 60));

            if (dataObject.senderUserId && dataObject.senderUserId == currentUser.id) {
                // console.log('openMessage', "dataObject.senderUserId==currentUser.id")
                if (dataObject.receiverUserId && dataObject.receiverUserId != undefined) {
                    // console.log('openMessage', dataObject.receiverUserId)

                    wData = await whatsAppModel.whatsappGetMessage({
                        UserId: dataObject.receiverUserId
                    });
                    console.log('openMessage 553', wData, wData.messages)


                    // check if pass 24 hours from createdDate
                    if (dataObject.createdDate && diffHours > 24 || dataObject.isTemplate || dataObject.isTransfer) {
                        setMessageText("שלום, כאן " + JSON.parse(loggedUser).name + " " + getDepartment(currentUser.role) + " " + getBranch(currentUser.branchName) + ": ");
                    } else {
                        setMessageText("");
                    }
                    //setCustomerPhoneNumber(null);
                    setCustomerPhoneNumber(dataObject.receiverPhoneNumber);
                    setCustomerName(dataObject.receiverUser.fullName)
                    setUserId(dataObject.receiverUserId);
                }
                else {
                    wData = await whatsAppModel.whatsappGetMessage({
                        CustomerPhoneNumber: dataObject.receiverPhoneNumber
                    });
                    console.log('openMessage 571', wData, wData.messages)

                    // check if pass 24 hours from createdDate
                    if ((dataObject.createdDate && diffHours > 24) || dataObject.isTemplate || dataObject.isTransfer) {
                        setMessageText("שלום, כאן " + JSON.parse(loggedUser).name + " " + getDepartment(currentUser.role) + " " + getBranch(currentUser.branchName) + ": ");
                    } else if (
                        // checkLastMessageFromSender(currentUser.id) &&
                        dataObject.senderUser && dataObject.senderUser.id != currentUser.id) {
                        setMessageText("שלום, כאן " + JSON.parse(loggedUser).name + " " + getDepartment(currentUser.role) + " " + getBranch(currentUser.branchName) + ": ");
                    } else {
                        setMessageText("");
                    }
                    // setMessageText("שלום, כאן "+JSON.parse(loggedUser).name+" "+getDepartment(currentUser.role)+": ");
                    setCustomerPhoneNumber(dataObject.receiverPhoneNumber);
                    setCustomerName(dataObject.customerName);
                    setUserId(dataObject.receiverUserId);
                    //setUserId(null);
                }
            }
            else {
                console.log('openMessage', "dataObject.senderUserId!=currentUser.id")
                if (dataObject.senderUserId && dataObject.senderUserId != undefined) {
                    wData = await whatsAppModel.whatsappGetMessage({
                        UserId: dataObject.senderUserId
                    });
                    console.log('openMessage 597', wData, wData.messages)

                    if (dataObject.createdDate && diffHours > 24 || dataObject.isTemplate || dataObject.isTransfer) {
                        setMessageText("שלום, כאן " + JSON.parse(loggedUser).name + " " + getDepartment(currentUser.role) + " " + getBranch(currentUser.branchName) + ": ");
                    } else if (dataObject.senderUser && dataObject.senderUser.id != currentUser.id) {
                        setMessageText("שלום, כאן " + JSON.parse(loggedUser).name + " " + getDepartment(currentUser.role) + " " + getBranch(currentUser.branchName) + ": ");
                    } else {
                        setMessageText("");
                    }
                    //setCustomerPhoneNumber(null);
                    setCustomerPhoneNumber(dataObject.senderPhoneNumber);
                    setCustomerName(dataObject.senderUser.fullName)
                    setUserId(dataObject.senderUserId);
                }
                else {
                    wData = await whatsAppModel.whatsappGetMessage({
                        CustomerPhoneNumber: dataObject.senderPhoneNumber
                    });
                    console.log('openMessage 616', wData, wData.messages)

                    if (dataObject.createdDate && diffHours > 24 || dataObject.isTemplate) {
                        setMessageText("שלום, כאן " + JSON.parse(loggedUser).name + " " + getDepartment(currentUser.role) + " " + getBranch(currentUser.branchName) + ": ");
                    } else if (dataObject.senderUser && dataObject.senderUser.id != currentUser.id) {
                        setMessageText("שלום, כאן " + JSON.parse(loggedUser).name + " " + getDepartment(currentUser.role) + " " + getBranch(currentUser.branchName) + ": ");
                    } else {
                        setMessageText("");
                    }
                    setCustomerName(dataObject.customerName);
                    setCustomerPhoneNumber(dataObject.senderPhoneNumber);
                    //setUserId(null);
                    setUserId(dataObject.senderUserId);
                }
            }

            //const message = messages.find((m: any) => m.customerPhoneNumber == dataObject.CustomerPhoneNumber);


            console.log('openMessage', wData, wData.messages)
            setShowNewMessage(false);

            setSelectedMessage(wData.messages);
            console.log(wData.messages);
            const subMessages = fixSubMessages(wData.messages);




            await setSubMessages(subMessages);
            if (menuRef.current) {
                menuRef.current.getWhatsappMessagesCounter();
            }

        }





    }

    const fixSubMessages = (messages: any[]) => {
        const subMessages: any[] = [];
        messages.forEach((message: any) => {
            if (message.isTransferMessage && message.isTransferMessage == true) {
                const d = prepareDate(message.transferDate)
                message.date = d.date;
                message.time = d.time;
            }
            else {
                const d = prepareDate(message.createdDate ? message.createdDate : new Date().getTime());
                message.date = d.date;
                message.time = d.time;
            }

            message.createdDate = message.createdDate ? message.createdDate : new Date().getTime();


            message.direction = 'left';
            // if (userId) {
            //     if (userId === message.senderUserId) {
            //         message.direction = 'left';
            //     } else {
            //         message.direction = 'right';
            //     }
            // } else {
            //     if (customerPhoneNumber === message.senderPhoneNumber) {
            //         message.direction = 'left';
            //     } else {
            //         message.direction = 'right';
            //     }
            // }
            if (message.senderUserId == undefined || message.receiverUserId == undefined) {
                if (message.senderUserId != undefined) {
                    message.direction = 'right';
                }
                else {
                    message.direction = 'left';
                }
            }
            else {
                if (message.senderUserId == curUserId) {
                    message.direction = 'right';
                }
                else {
                    message.direction = 'left';
                }
            }


            message.hasImage = false;
            message.hasFile = false;
            message.messageText = message.text;
            if (message.text && message.text.indexOf('image;') > -1) {
                message.hasImage = true;
                // m.imageName = 'image';
                message.imageUrl = message.text.replace('image;', '');
                message.messageText = '';
            }
            if (message.text && message.text.indexOf('document;') > -1) {
                message.hasFile = true;
                message.fileUrl = message.text.replace('document;', '');
                message.fileName = message.fileUrl.substring(message.fileUrl.lastIndexOf('/') + 1);
                message.messageText = '';
            }

            subMessages.push(message);
        });
        return subMessages;
    }

    const onStarClick = async (starShow: boolean, dataObject: any) => {
        try {
            if (starShow) {
                const show = await whatsAppModel.whatsappSolidStar(dataObject);
            } else {
                const hide = await whatsAppModel.whatsappLightStar(dataObject);
            }
        } catch (error) {

        }
    }

    const closeMessage = () => {
        setCustomerPhoneNumber(null);
        setCustomerName("")
        setUserId(null);
        setSelectedMessage(null);
    }
    const openForward = () => {

        setForwardStatus(true);
        setTransferMessage("");
    }


    const handleOnFileClick = (event: any) => {
        setsoundFile(false);
        console.log('handleOnFileClick');
        if (hiddenFileInput && hiddenFileInput.current) {
            hiddenFileInput.current.click();
        }
    };
    const handleOnFileClick2 = (event: any) => {
        setsoundFile(false);
        console.log('handleOnFileClick2');
        if (newMessageUserId && newMessageUserId !== '') {
            if (hiddenFileInput2 && hiddenFileInput2.current) {
                hiddenFileInput2.current.click();
            }
        }
    };

    const handleOnFileChange = (event: any) => {
        const fileUploaded = event.target.files[0];
        if (isSoundFile(event.target.files.length > 0 && event.target.files[0].name)) {
            setsoundFile(true);
            return;
        }
        const fileSize: string = ((fileUploaded.size / 1024) / 1024).toFixed(4);
        if (parseFloat(fileSize) > 5) {
            return;
        }
        const reader = new FileReader();
        if (reader !== undefined && fileUploaded !== undefined) {
            reader.onloadend = () => {
                //   setFile(file)
                //   setSize(file.size);
                //   setName(file.name)
                //   setImagePreview(reader.result)
                console.log(reader.result);
                setMessageImg({
                    FileName: (new Date().getTime()) + "_" + fileUploaded.name,
                    Content: reader.result
                });
                setMessageImgSend(Date.now());
            }
            reader.readAsDataURL(fileUploaded);
        }
        console.log('handleOnFileChange', fileUploaded);
        // handleFile(fileUploaded);
    };



    const isSoundFile = (filename: string) => {
        const soundExtensions = [
            // Sound extensions
            '.mp3', '.wav', '.ogg', '.flac', '.aac', '.m4a',
            // Video extensions
            '.mp4', '.avi', '.mov', '.wmv', '.flv', '.mkv', '.webm'
        ];
        const extension = filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
        return soundExtensions.includes(`.${extension}`);
    };

    const handleOnFileChange2 = (event: any) => {
        const fileUploaded = event.target.files[0];
        const fileSize: string = ((fileUploaded.size / 1024) / 1024).toFixed(4);
        if (parseFloat(fileSize) > 5) {
            return;
        }
        const reader = new FileReader();
        if (reader !== undefined && fileUploaded !== undefined) {
            reader.onloadend = () => {
                //   setFile(file)
                //   setSize(file.size);
                //   setName(file.name)
                //   setImagePreview(reader.result)
                console.log(reader.result);
                setNewMessageImg({
                    FileName: (new Date().getTime()) + "_" + fileUploaded.name,
                    Content: reader.result
                });
            }
            reader.readAsDataURL(fileUploaded);
        }
        console.log('handleOnFileChange', fileUploaded);
        // handleFile(fileUploaded);
    };

    const onTextMessageChange = (e: any) => {
        setsoundFile(false);
        setTransferMessage("");
        setMessageText(e);
    }

    const sendMessage = async () => {

        if (!customerPhoneNumber) {
            return;
        }
        setSendMessageLoading(true);

        console.log("1");
        let data: any = null;
        const requestData: any = {}
        if (messageImg) {
            requestData.Files = [
                {
                    FileName: messageImg.FileName,
                    Content: messageImg.Content
                }
            ]
            console.log("2 - image");
        } else {
            if (messageText == '') return;
            requestData.text = messageText;
            console.log("2 - !image");
        }
        if (userId) {
            requestData.UserId = userId;
            console.log("3 - userId");
            data = await whatsAppModel.whatsappSendMessageInner(requestData);
            setMessageText('');
        } else {
            requestData.customerPhoneNumber = customerPhoneNumber;
            console.log("3 - !userId");
            data = await whatsAppModel.whatsAppSendMessage(requestData);
            const loggedUser = localStorage.getItem("loggedUser");
            if (loggedUser)
                setMessageText("");
        }
        console.log("4");
        // if (data) {

        // var old = subMessages.find(item => item.connectedUserId === userId);[0]
        var old = subMessages.find(item => item.connectedUserId === userId);

        if (old != null) {

            if (messageImg) {
                old.hasFile = true;
                old.fileUrl = messageImg.FileName;
            }
            else {
                old.messageText = requestData.text;

            }

            // const _subMessages = fixSubMessages(wData.messages);
        }

        let wData = null;
        if (userId) {
            wData = await whatsAppModel.whatsappGetMessage({
                UserId: userId
            })
        } else {
            wData = await whatsAppModel.whatsappGetMessage({
                CustomerPhoneNumber: customerPhoneNumber
            })
        }
        const _subMessages = fixSubMessages(wData.messages);
        await setSubMessages(_subMessages);


        if (messageImg) {
            setMessageImg(null);
        }

        load(messageFilter);
        setSendMessageLoading(false);

        // }
    }
    const toggleNewMessage = () => {
        setCustomerPhoneNumber(null);
        setCustomerName("");
        setSelectedMessage(null);
        setShowNewMessage(!showNewMessage);
        getRecipientsList().then(() => {
            console.log('recipients loaded')
        })
    }

    const sendNewMessage = async () => {

        if (!newMessageUserId) return;
        const requestData: any = {
            UserId: newMessageUserId
        }
        if (newMessageImg) {
            requestData.Files = [
                {
                    FileName: newMessageImg.FileName,
                    Content: newMessageImg.Content
                }
            ]
        } else {
            if (newMessageText == '') return;
            requestData.text = newMessageText;
        }
        const data = await whatsAppModel.whatsappSendMessageInner(requestData);
        setCustomerPhoneNumber(null);
        setCustomerName("");

        setSelectedMessage(null);
        setShowNewMessage(false);
        if (newMessageImg) {
            setNewMessageImg(null);
        }
        setNewMessageText('');
        setNewMessageRecipientName('');
        load();
    }
    const handleKeyPress = async (e: any) => {
        console.log(`Key pressed: ${e.key}`);  // Debug log

        if (e.key === 'Enter') {
            console.log(`Enter`);  // Debug log
            console.log("sendMessage 2");
            await sendMessage();
        }
    };

    const onNewTextMessageChange = (e: any) => {


        setNewMessageText(e);

    }
    const isGuid = (str: string) => {
        //      const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

        return guidPattern.test(str);
    };

    const onRecipientSelect = (fullName: string) => {
        const recipient = recipients.filter((r: any) => r.fullName !== null && r.fullName === fullName);
        if (recipient.length > 0) {
            setNewMessageRecipientName(recipient[0].fullName);
            setNewMessageUserId(recipient[0].id);
        }
    }
    const handleRecipientsSearch = (value?: string) => {
        setRecipentsOptions(() => {
            if (!value) {
                return recipients.map((recipient, i) => {
                    const online = recipient.lastLogIn > recipient.lastLogOut && moment(recipient.lastLogIn).isAfter(moment().startOf('day'));
                    let style: any = { color: 'red' };
                    if (online) {
                        style = { color: 'green' };
                    }
                    return {
                        label: (<span style={style}>{recipient.fullName}</span>),
                        value: `${recipient.id}`,
                    }
                });
            }
            const filtered: any[] = recipients.filter((o: any) => o.fullName.indexOf(value) > -1);
            console.log('handleRecipientsSearch', filtered)
            const recipientsList = filtered.map((recipient, i) => {
                let style: any = { color: recipient.type };
                if (recipient.online) {
                    style = { color: 'green' };
                }
                return {
                    label: (<span style={style}>{recipient.fullName}</span>),
                    value: `${recipient.id}`,
                }
            });
            return recipientsList;
        });
    };

    const onRecipientChange = (value: string) => {
        console.log('onRecipientChange', value);
        const r = recipientsAutoComplete.find((o: any) => o.val == value);
        if (r) {
            setNewMessageRecipientName(r.label);
            setNewMessageUserId(value);
        }
    }

    const onRecipientClear = () => {
        setNewMessageRecipientName('');
        setNewMessageUserId(null);
        handleRecipientsSearch();
    }




    const onForwardRecipientChange = (event: any) => {
        const filteredRcipients = recipients.filter((r: any) => r.fullName !== null && r.fullName.indexOf(event.currentTarget.value) > -1);
        setForwardMessageRecipientName(event.currentTarget.value);
        setRecipientsAutoComplete(filteredRcipients.map((r: any) => {
            const online = r.lastLogIn > r.lastLogOut && moment(r.lastLogIn).isAfter(moment().startOf('day'));
            return {
                label: r.fullName,
                val: r.id,
                type: online ? 'greem' : 'red',
                online: online
            }
        }))
    }
    const onForwardRecipientSelect = (fullName: string) => {

        if (fullName != "") {
            const recipient = recipients.find((r: any) => r.fullName === fullName);
            setForwardMessageRecipientName(recipient.fullName);
            setForwardMessageRecipientPhoneNumber(recipient.phoneNumber);
            setForwardMessageRecipientUserId(recipient.id);
        }
        else {
            setForwardMessageRecipientName("");
            setForwardMessageRecipientPhoneNumber("");
            setForwardMessageRecipientUserId("");
        }

    }

    const onTransferTypeSelect = (e: any) => {

        setTransferType(parseInt(e.currentTarget.value));
        setTransferMessage("");
    }

    const forwardMessage = () => {

        whatsAppModel.whatsappTransfer({
            TransferTo: forwardMessageRecipientUserId,
            TransferFromUserId: userId,
            CustomerPhoneNumber: customerPhoneNumber,
            transferType: transferType == null ? 0 : transferType
        }).then((res) => {
            setForwardStatus(false);
            setTransferMessage("הודעה הועברה ל" + forwardMessageRecipientName);
        })

    }

    const onDateChange = (newDate: Date, target: string) => {
        if (!newDate || newDate == undefined) {
            const filter = messageFilter;
            switch (target) {
                case 'start':
                    filter.fromDate = "";
                    setStartFilterDate(newDate);
                    break;
                case 'end':
                    filter.toDate = "";

                    setEndFilterDate(newDate);
                    break;
                default:
                    break;
            }
            setFilterChanged(true);
            return;

        }
        const dateString = newDate.toLocaleString('en-GB', { year: 'numeric', month: 'numeric', day: 'numeric' });
        console.log(dateString, target);
        const filter = messageFilter;
        switch (target) {
            case 'start':
                filter.fromDate = dateString;
                setStartFilterDate(newDate);
                break;
            case 'end':
                filter.toDate = dateString;
                setEndFilterDate(newDate);
                break;
            default:
                break;
        }

        setFilterChanged(true);
    }

    const onSearchTextChange = (e: any) => {
        console.log(e);
        // remove 0 from the beginning of the number and add 972 instead
        let fullNumber = e.target.value.trim();
        // if (fullNumber.length == 10 && fullNumber[0] == '0') {
        //     fullNumber = '972' + fullNumber.substring(1);
        // }
        console.log('fullNumber', fullNumber)
        const searchText = e.target.value.trim();
        setSearchText(e.target.value);
        const filter = messageFilter;
        if (searchText != '') {
            filter.searchText = fullNumber;
            setMessageFilter(filter);
            if (/*searchText.length >= 3*/true) {
                setFilterChanged(true);
            }
        } else {
            filter.searchText = undefined;
            setMessageFilter(filter);
            setFilterChanged(true);
        }
    }




    const onSearchStatusChange = (newValue: string) => {
        var status = parseInt(newValue);
        setSearchStatus(newValue);
        const filter = messageFilter;

        filter.searchStatus = status;
        setMessageFilter(filter);
        setFilterChanged(true);


    }
    const clearFilter = async () => {
        const filter: any = {
            searchText: undefined,
            fromDate: undefined,
            toDate: undefined,
            type: 'all',
            page: 1
        };
        setStartFilterDate(null);
        setEndFilterDate(null);
        setSearchText('');
        await setMessageFilter(filter);
        load(filter);
    }

    const onFolderClick = (type: string) => {
        setFolderType(type);
        const filter = messageFilter;
        filter.type = type;
        setMessageFilter(filter);
        setFilterChanged(true);
    }

    useEffect(() => {
        console.log('init')
        checkLastMessageFromClient(subMessages);
    }, [])


    const addEmoji1 = (emoji: any) => {
        if (newMessageText == undefined)
            setNewMessageText(emoji);
        else {
            setNewMessageText(newMessageText + emoji);
        }
        setShowEmoji1(false);
    };

    const addEmoji2 = (emoji: any) => {
        if (messageText == undefined)
            setMessageText(emoji);
        else {
            setMessageText(messageText + emoji);
        }
        setShowEmoji2(false);
    };

    const showEmojiList2 = () => {

        setShowEmoji2(true);
    }

    const showEmojiList1 = () => {

        setShowEmoji1(true);
    }

    const onNewMessageArrived = async (messageType: string, message: any) => {
        console.log('onNewMessageArrived', messageType, message);
        console.log('CustomerPhoneNumber', customerPhoneNumber, message.CustomerPhoneNumber.replace(/^(\+?972)/, '0'));
        console.log('SenderPhoneNumber', customerPhoneNumber, message.SenderPhoneNumber.replace(/^(\+?972)/, '0'));

        if (customerPhoneNumber && message.SenderPhoneNumber.replace(/^(\+?972)/, '0') == customerPhoneNumber.replace(/^(\+?972)/, '0')) {

            console.log('list-whatsapp 2:', message);
            let newMessageWhatsApp: any = {}
            // copy message to newMessageWhatsApp as any and not as WhatsAppMessage
            newMessageWhatsApp = {
                ...Object.fromEntries(
                    Object.entries(message).map(([key, value]) => [key.charAt(0).toLowerCase() + key.slice(1), value])
                ),
            }

            console.log('newMessageWhatsApp', newMessageWhatsApp)

            const newSubMessages = fixSubMessages([newMessageWhatsApp]);
            await setSubMessages((prevMessages) => [...prevMessages, ...newSubMessages]);

        }

        // await setSubMessages(subMessages);
    }

    // useEffect(() => {
    //     let lastMessage = checkLastMessageFromClient(subMessages);
    //     setStatusOfLastMessage(lastMessage);

    // }, [subMessages]);


    const downloadImage = (message: any) => {
        let documentUrl = '';
        if (message.imageUrl && (message.imageUrl.indexOf('https://') > -1 || message.imageUrl.indexOf('https://') > -1)) {
            documentUrl = message.imageUrl;
        } else {
            // documentUrl = message.text.split('image;')[1];
        }
        console.log('documentUrl downloadDocument', message.hasImage, message.imageUrl)
        // let urlLink = apiUrl + imageUrl.split('co.il')[1]

        if (message && message.imageUrl && message.imageUrl.length > 0) {
            const fileUrl = `${message.imageUrl}`;
            const anchor = document.createElement('a');
            anchor.href = `${message.imageUrl}`;
            anchor.download = 'filename.png'; // Set the filename you want
            anchor.target = '_blank';
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }

    const downloadDocument = (message: any) => {

        console.log('documentUrl downloadDocument', message)
        // let urlLink = apiUrl + imageUrl.split('co.il')[1]

        if (message && message.fileUrl && message.fileUrl.length > 0) {
            const fileUrl = `${message.fileUrl}`;
            const anchor = document.createElement('a');
            anchor.href = fileUrl;
            anchor.download = 'filename.pdf'; // Set the filename you want
            anchor.target = '_blank';
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }

    const checkLastMessageFromClient = (messages: any[]) => {

        let receiverUserMessages = subMessages.filter((m: any) => m.receiverUser);
        console.log('receiverUserMessages', receiverUserMessages);
        if (receiverUserMessages.length > 0) {
            const lastMessage = receiverUserMessages[receiverUserMessages.length - 1];
            // check if pass 24 hours from createdDate
            const createdDate = new Date(lastMessage.createdDate);
            const currentDate = new Date();
            const diffTime = Math.abs(currentDate.getTime() - createdDate.getTime());
            const diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
            console.log('diffHours', diffHours)
            console.log('subMessages', subMessages)
            console.log('subMessages[subMessages.length - 1]', subMessages[subMessages.length - 1])
            if (subMessages[subMessages.length - 1]
                && subMessages[subMessages.length - 1].senderPhoneNumber == subMessages[subMessages.length - 1].customerPhoneNumber) {
                // 
                let lastMessageDateasMoment = moment(subMessages[subMessages.length - 1].date + 'T' + subMessages[subMessages.length - 1].time, 'DD/MM/YYYYTHH:mm');
                console.log('lastMessageDateasMoment', lastMessageDateasMoment)
                let lastMessageDate = new Date(lastMessageDateasMoment.format('YYYY-MM-DD HH:mm:ss'));
                console.log('lastMessageDate', lastMessageDate)
                let newlastMessageDate = lastMessageDate.getTime();
                console.log('newlastMessageDate', newlastMessageDate)
                let lastMessageDiffrentTime = Math.abs(currentDate.getTime() - newlastMessageDate);
                console.log('lastMessageDiffrentTime', lastMessageDiffrentTime)
                const lastMessageDiffHours = Math.ceil(lastMessageDiffrentTime / (1000 * 60 * 60));
                console.log('lastMessageDiffHours', lastMessageDiffHours);
                if (lastMessageDiffHours < 24 && !subMessages[subMessages.length - 1].isTemplate) {
                    return false;
                }
            }


            if (diffHours > 24 && !subMessages[subMessages.length - 1].isTemplate) {
                return true;
            }
        }
        return false;

    }

    const createTreatment = async () => {
        let receiverUserMessages = subMessages.filter((m: any) => m.receiverUser);
        if (receiverUserMessages.length > 0) {
            const lastMessage = receiverUserMessages[receiverUserMessages.length - 1];
            console.log('createTreatment-lastMessage', lastMessage);
            let resId = await whatsAppModel.whatsappGetIdByPhone(lastMessage.customerPhoneNumber);

            let res = await whatsAppModel.whatsappSendFollowUpMessage({
                id: resId,
            });
            console.log('create Treatment :>> ', res);
            if (res) {
                await openMessage(openClientMessages);
            }
            // if(res){
            //     setSelectedMessage(null);
            // }
        }

    }


    return (
        <>
            <WebsocketMessages updateMessages={onNewMessageArrived} />
            <div className="main-content rtl">
                {
                    !userLogged && <LoginPopup />
                }

                <Menu activePage='Whatsapp' ref={menuRef} />
                <div className="center-content">
                    <Header PageName="וואצפ" />
                    <section className="page-tab-row">
                        <div className="emails-tab-row-container">
                            <div className="emails-tab-row">
                                <div className="email-tab email-tab-clients selected">
                                    <div className="top-border"></div>
                                    <div className="tab-content">
                                        <div className="label">
                                            הודעות
                                        </div>
                                        <div className="icon-holder pointer">
                                            <div className="icon x-close-grey"></div>
                                        </div>
                                    </div>
                                </div>


                                <div className="email-tab new-email-tab hidden">
                                    <div className="top-border"></div>
                                    <div className="tab-content">
                                        <div className="label">
                                            הודעה חדשה
                                        </div>
                                        <div className="icon-holder pointer">
                                            <div className="icon x-close-grey"></div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>
                    <section className="page-tab-content selected all-emails" id="all-emails">
                        <section className="main-body only-emails flex-centered flex-space-between">
                            <div className="emails-content-column emails-right-column">
                                <button type="button" className="new-email button blue flex-centered flex-justify-center pointer" onClick={() => toggleNewMessage()}>
                                    הודעה חדשה
                                </button>
                                <div className="emails-menu">
                                    <div className={`emails-menu-item pointer ${folderType == 'all' ? 'selected' : ''}`} onClick={() => onFolderClick('all')}>
                                        <div className="label">
                                            הכל
                                        </div>
                                        <div className="counter">

                                        </div>
                                    </div>
                                    <div className={`emails-menu-item pointer ${folderType == 'income' ? 'selected' : ''}`} onClick={() => onFolderClick('income')}>
                                        <div className="label">
                                            הודעות נכנסות
                                        </div>
                                        <div className="counter">
                                        </div>
                                    </div>
                                    <div className={`emails-menu-item pointer ${folderType == 'star' ? 'selected' : ''}`} onClick={() => onFolderClick('star')}>
                                        <div className="label">
                                            מסומן בכוכב
                                        </div>
                                        <div className="counter">
                                        </div>
                                    </div>
                                    <div className={`emails-menu-item pointer ${folderType == 'out' ? 'selected' : ''}`} onClick={() => onFolderClick('out')}>
                                        <div className="label">
                                            נשלח
                                        </div>
                                        <div className="counter">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="emails-content-column content-body emails-list emails-list-view">
                                <div className="filter-row">
                                    <div className="filter-input search">
                                        <input type="text" placeholder="חיפוש" value={searchText} onChange={(e: any) => onSearchTextChange(e)} />
                                        <div className="icon search"></div>
                                    </div>
                                    <div className="filter-input">

                                        <CompDatePicker value={startFilterDate ? startFilterDate : null} onChange={(e: any) => onDateChange(e, 'start')} />

                                    </div>
                                    <div className="filter-input">
                                        <CompDatePicker value={endFilterDate ? endFilterDate : null} onChange={(e: any) => onDateChange(e, 'end')} />

                                    </div>
                                    <div className="filter-input select">

                                        <Select
                                            style={{ width: '100%' }}
                                            placeholder="נא לבחור"
                                            defaultValue={searchStatus}
                                            value={searchStatus}
                                            onChange={onSearchStatusChange}
                                            options={
                                                [
                                                    {
                                                        label: 'הכל',
                                                        value: '0'
                                                    },
                                                    {
                                                        label: 'לא קראתי',
                                                        value: '1'
                                                    },
                                                    {
                                                        label: 'קראתי',
                                                        value: '2'
                                                    }
                                                ]
                                            }
                                        />
                                    </div>
                                    <div className="filter-button">
                                        <div className="icon refresh-counter pointer" onClick={clearFilter}></div>
                                    </div>
                                </div>
                                <div>
                                    {messages.map((message: any, i: number) => {
                                        return (
                                            <EmailMessageItem message={message} openMessage={openMessage} onStarClick={onStarClick} key={i} ></EmailMessageItem>
                                        )
                                    }
                                    )}

                                </div>
                            </div>

                            {selectedMessage &&
                                <div className={`emails-content-column emails-left-column whatsapp-left-column ${customerPhoneNumber != null ? 'show' : ''}`}>
                                    <div className="close-icon pointer" onClick={() => setCustomerPhoneNumber(null)}></div>
                                    <div className="email-content">
                                        <div className="top-row">
                                            <div className="title whatsapptitle">
                                                <div className='rightFloat'>{customerName}</div>
                                                <div className='leftFloat'>{customerPhoneNumber ? customerPhoneNumber.replace(/^972/, "0") : ""}</div>

                                            </div>
                                            <div>
                                                <div className={`icon star${selectedMessage.star ? ' selected' : ''}`}></div>
                                            </div>
                                        </div>
                                        <div ref={messagesDivRef} className='vert-scrolling messages-list'>
                                            {subMessages.map((message: any, i: number) => {
                                                return (
                                                    <div className={`message-row whatsapp-message-row ${message.direction} `} key={i}>
                                                        <div className={` whatsapp-message ${message.direction}`}>
                                                            {
                                                                message.hasImage ? <div className="whatsapp-message-text">
                                                                    <img src={message.imageUrl} className='message-image' />
                                                                    {
                                                                        message.imageUrl && message.imageUrl.length > 0 ?

                                                                            <Tooltip title="הורדה">
                                                                                <DownloadOutlined style={{
                                                                                    fontSize: '22px',
                                                                                    marginLeft: '20px',
                                                                                    color: '#186cc7'
                                                                                }} onClick={() => downloadImage(message)}
                                                                                />
                                                                            </Tooltip>
                                                                            : <></>
                                                                    }
                                                                </div> : <></>
                                                            }
                                                            {
                                                                message.hasFile ? <div className="whatsapp-message-text">
                                                                    {/* <a href={message.fileUrl} className='message-image'> */}
                                                                    <div className="icon document-icon"></div>
                                                                    <div>{message.fileName}</div>

                                                                    <Tooltip title="הורדה">
                                                                        <DownloadOutlined style={{
                                                                            fontSize: '22px',
                                                                            marginLeft: '20px',
                                                                            color: '#186cc7'
                                                                        }} onClick={() => downloadDocument(message)}
                                                                        />
                                                                    </Tooltip>
                                                                </div> : <></>
                                                            }
                                                            <div className="whatsapp-message-text">
                                                                <div>{message.senderUser != null ? (message.senderUserId == curUserId ? "אני" : message.senderUser.fullName) : message.customerName}:</div>
                                                                <div className={`${message.isTransfer && message.isTransfer == 1 ? "transferMessge" : ""}`}>{message.messageText}</div>
                                                            </div>

                                                            <div className="message-date">
                                                                <div>
                                                                    {message.date}
                                                                </div>
                                                                <div>&nbsp;</div>
                                                                <div>
                                                                    {message.time}
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            )}
                                        </div>
                                        {checkLastMessageFromClient(subMessages) ? (
                                            <div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                    <div className={` whatsapp-message right`} style={{ width: '40%' }}>
                                                        <button className="btn-new-msg" onClick={() => createTreatment()}>התחל שיחה עם לקוח ← </button>
                                                    </div>

                                                    <div className={` whatsapp-message right`} style={{ width: 'fit-content', padding: 0,backgroundColor: '#ffffff',height: 'fit-content' ,marginTop: '30px' }}>
                                                        <button className="btn-new-msg" onClick={openForward}>העברת התכתבות</button>
                                                    </div>
                                                </div>

                                                <div className={forwardStatus ? "filter-row" : "hide"}>
                                                    <div>
                                                        <input type='text' placeholder='שם'
                                                            list="recipientsAutoComplete_list"
                                                            value={forwardMessageRecipientName}
                                                            onChange={(e: any) => onForwardRecipientChange(e)}
                                                            onBlur={(e: any) => onForwardRecipientSelect(e.currentTarget.value)}
                                                        />
                                                        <datalist id="recipientsAutoComplete_list">
                                                            {recipientsAutoComplete.map((o, i) => <option key={i} id={o.val} value={o.label}>{ }</option>)}
                                                        </datalist>
                                                    </div>
                                                    <div>
                                                        <select onChange={onTransferTypeSelect}>
                                                            <option value={0}>הכל</option>
                                                            <option value={1}>שבוע</option>
                                                            <option value={2}>חודש</option>
                                                            <option value={3}>שנה</option>
                                                        </select>
                                                    </div>
                                                    <button type="button" className="new-email button blue flex-centered flex-justify-center pointer" onClick={() => forwardMessage()}>
                                                        העברה
                                                    </button>

                                                </div>
                                            </div>

                                        )
                                            :
                                            <div className="message-footer whatsapp-message-footer">
                                                <div className="filter-row">
                                                    <div className="filter-input send-message">
                                                        {/*<input type="text" multiple placeholder="כתוב הודעה..." onKeyDown={handleKeyPress} value={messageText} onChange={(e: any) => onTextMessageChange(e.target.value)} />*/}
                                                        <textarea placeholder="כתוב הודעה..." rows={1} className='textArea' value={messageText} onKeyDown={handleKeyPress} onChange={(e: any) => onTextMessageChange(e.target.value)}></textarea>

                                                        <div className='share' onClick={openForward}><FontAwesomeIcon icon={faShare} /></div>
                                                        <div className='share' onClick={showEmojiList2}><FontAwesomeIcon icon={faFaceSmile} /></div>
                                                        <div className="icon paperclip pointer" onClick={handleOnFileClick}></div>
                                                        <input type="file" accept="image/png, image/gif, image/jpeg, application/pdf, application/msword,.doc,.docx" hidden ref={hiddenFileInput} onChange={handleOnFileChange} />
                                                        <div className="icon email" onClick={sendMessage}></div>
                                                        <img src={require("../assets/images/loading.gif")} className={sendMessageLoading ? "loadingGif" : "hide"} />
                                                        <div className={showEmoji2 ? "emoji-container" : "hide"}>
                                                            {emojiList.map((emoji: string, index: number) => (
                                                                <span key={index} className="emoji-button" onClick={() => addEmoji2(emoji)}>{emoji}</span>
                                                            ))}

                                                            {/* Add more emojis as needed */}
                                                        </div>

                                                    </div>

                                                </div>
                                                <div className='sounddddd error-message'>{soundFile ? "המערכת לא תומכת בקבצי סאונד" : ""}</div>
                                                <div className='error-message'>{transferMessage}</div>
                                                <div className={forwardStatus ? "filter-row" : "hide"}>

                                                    <div>


                                                        <input type='text' placeholder='שם'
                                                            list="recipientsAutoComplete_list"
                                                            value={forwardMessageRecipientName}
                                                            onChange={(e: any) => onForwardRecipientChange(e)}
                                                            onBlur={(e: any) => onForwardRecipientSelect(e.currentTarget.value)}
                                                        />
                                                        <datalist id="recipientsAutoComplete_list">
                                                            {recipientsAutoComplete.map((o, i) => <option key={i} id={o.val} value={o.label}>{ }</option>)}
                                                        </datalist>
                                                    </div>
                                                    <div>
                                                        <select onChange={onTransferTypeSelect}>
                                                            <option value={0}>הכל</option>
                                                            <option value={1}>שבוע</option>
                                                            <option value={2}>חודש</option>
                                                            <option value={3}>שנה</option>
                                                        </select>
                                                    </div>
                                                    <button type="button" className="new-email button blue flex-centered flex-justify-center pointer" onClick={() => forwardMessage()}>
                                                        העברה
                                                    </button>

                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>}
                            <div className={`emails-content-column emails-left-column whatsapp-left-column ${showNewMessage ? 'show' : ''}`}>
                                <div className="close-icon pointer" onClick={() => setShowNewMessage(false)}></div>
                                <div>




                                    {/* <input type='text' placeholder='בחר'
                                        list="newMessageRecipient_list"
                                        value={newMessageRecipientName}
                                        onChange={(e: any)=>onRecipientChange(e)}
                                        onBlur={(e: any)=>onRecipientSelect(e.currentTarget.value)}
                                    />
                                    <datalist id="newMessageRecipient_list">
                                        {recipientsAutoComplete.map((o, i)=><option key={i} id={o.val} placeholder='בחר' value={o.label}>{}</option>)}
                                    </datalist> */}
                                    <AutoComplete
                                        style={{ width: 200 }}
                                        value={newMessageRecipientName}
                                        onSearch={handleRecipientsSearch}
                                        onChange={onRecipientChange}
                                        onClear={onRecipientClear}
                                        allowClear={true}
                                        placeholder="בחר 1"
                                        options={recipentsOptions}
                                    />

                                </div>
                                <div className="message-footer whatsapp-message-footer">
                                    <div className="filter-row">
                                        <div className="filter-input send-message">
                                            {/*<input type="text" multiple placeholder="כתוב הודעה..." value={newMessageText}   onChange={(e: any) => onNewTextMessageChange(e.target.value)} />*/}
                                            <textarea placeholder="כתוב הודעה..." rows={1} className='textArea' value={newMessageText} onChange={(e: any) => onNewTextMessageChange(e.target.value)}></textarea>
                                            <div className='share' onClick={showEmojiList1}><FontAwesomeIcon icon={faFaceSmile} /></div>
                                            <div className={showEmoji1 ? "emoji-container" : "hide"}>
                                                {emojiList.map((emoji: string, index: number) => (
                                                    <span key={index} className="emoji-button" onClick={() => addEmoji1(emoji)}>{emoji}</span>
                                                ))}
                                                {/* Add more emojis as needed */}
                                            </div>
                                            <div className="icon paperclip pointer" onClick={handleOnFileClick2}></div>
                                            {/* <input type="file" accept="image/png, image/gif, image/jpeg, application/pdf, application/msword,.doc,.docx" hidden ref={hiddenFileInput2} onChange={handleOnFileChange2} /> */}
                                            <input type="file" accept=".jpg, .jpeg, .png, .gif, .bmp, .svg, .doc, .docx, .pdf, .ppt, " hidden ref={hiddenFileInput2} onChange={handleOnFileChange2} />
                                            <div className="icon email" onClick={sendNewMessage}></div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </section>

                    </section>
                </div>


            </div>

            {/* {useWebScocket ? (<WhatsappWebsocketMessages updateMessages={updateMessages} ></WhatsappWebsocketMessages>) : ('')} */}

        </>
    )

}

export default Whatsapp;